<template>
  <g>
    <path
      d="M10.75 8.00024C10.34 8.00024 10 8.34024 10 8.75024V13.4402C10 13.7902 10.18 14.1102 10.47 14.2902L14.11 16.5302C14.44 16.7302 14.87 16.6402 15.08 16.3202C15.31 15.9802 15.2 15.5202 14.85 15.3102L11.5 13.3002V8.75024C11.5 8.34024 11.16 8.00024 10.75 8.00024Z"
    />
    <path
      d="M17.92 12.0002C17.97 12.3302 18 12.6602 18 13.0002C18 16.9002 14.9 20.0002 11 20.0002C7.1 20.0002 4 16.9002 4 13.0002C4 9.10024 7.1 6.00024 11 6.00024C11.7 6.00024 12.37 6.10024 13 6.29024V4.23024C12.36 4.08024 11.69 4.00024 11 4.00024C6 4.00024 2 8.00024 2 13.0002C2 18.0002 6 22.0002 11 22.0002C16 22.0002 20 18.0002 20 13.0002C20 12.6602 19.98 12.3302 19.94 12.0002H17.92Z"
    />
    <path
      d="M22 5.00024H20V3.00024C20 2.45024 19.55 2.00024 19 2.00024C18.45 2.00024 18 2.45024 18 3.00024V5.00024H16C15.45 5.00024 15 5.45024 15 6.00024C15 6.55024 15.45 7.00024 16 7.00024H18V9.00024C18 9.55024 18.45 10.0002 19 10.0002C19.55 10.0002 20 9.55024 20 9.00024V7.00024H22C22.55 7.00024 23 6.55024 23 6.00024C23 5.45024 22.55 5.00024 22 5.00024Z"
    />
  </g>
</template>
